import React, {useState, useEffect} from "react";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import CardContent from "@material-ui/core/CardContent";
import {lighten, makeStyles} from "@material-ui/core/styles";

import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";

import CreateCentroCustos from "./CreateCentroCustos";
import TableCentroCustos from "./TableCentroCustos";

import PageLoader from "@jumbo/components/PageComponents/PageLoader";
import {getToken} from "../../../services/auth";
import Swal from "sweetalert2";
import api from "../../../services/api";

import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    margin: "0 auto",
    backgroundColor: lighten(theme.palette.background.paper, 0.1)
  },
  textField: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(4),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(4),
    width: 400
  }
}));

const breadcrumbs = [
  {
    label: "Centro de Custos",
    link: "/",
    isActive: true
  }
];

export default function CentroCustos(){
  const classes = useStyles();
  const headers = {Authorization: "Bearer " + getToken()};
  const [ isLoading, setIsLoading ] = useState(true);
  const [ centroCusto, setCentroCusto ] = useState([]);
  const [ dataCentroCustoFiltered, setDataCentroCustoFiltered ] = useState([]);
  const [ dataFiltro, setDataFiltro ] = useState([]);

  useEffect(() => {
    getAllCentroCustos();
  }, []);

  const getAllCentroCustos = async () => {
    setIsLoading(true);
    try {
      api
        .get("ponto/centro-custos", {headers})
        .then(res => {
          setCentroCusto(res.data.data);
          setDataCentroCustoFiltered(res.data.data);
        })
        .catch(err => {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#3085D6",
            title: "Oops...",
            text: "Não conseguimos consultar os centro de custos"
          });
        });
      setIsLoading(false);
    } catch (err) {
      Swal.fire({
        icon: "error",
        confirmButtonColor: "#3085D6",
        title: "Oops...",
        text: "Não conseguimos conectar na api"
      });
    }
    setIsLoading(false);
  };

  function onChangeItem(item){
    getAllCentroCustos();
  }

  function handleSearch(search){
    setDataCentroCustoFiltered(centroCusto);
    setDataFiltro([]);

    if (search == "") {
      setDataCentroCustoFiltered(centroCusto);
    } else {
      dataCentroCustoFiltered.forEach(filter => {
        let busca = search
          .toUpperCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        let nome = filter.nome
          .toUpperCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        if (!dataFiltro.includes(filter) && nome.includes(busca)) {
          dataFiltro.push(filter);
        }

        setDataCentroCustoFiltered(dataFiltro);
      });
    }
  }

  return (
    <PageContainer heading="Centro de Custos" breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          <div style={{marginBottom: 10}}>Gerenciar Centro de Custos</div>
          <Divider />
          <div style={{marginTop: 24}}>
            <Card className={classes.root}>
              <CardContent>
                <CreateCentroCustos onChangeItem={onChangeItem} />
                <br />
                <br />
                <TextField
                  autoFocus
                  autoComplete={"off"}
                  variant="outlined"
                  id="search"
                  type="text"
                  className={classes.textField}
                  placeholder="Pesquise"
                  name="search"
                  onChange={e => {
                    handleSearch(e.target.value);
                  }}
                />
                {isLoading != true ? (
                  <TableCentroCustos
                    centroCusto={dataCentroCustoFiltered}
                    onChangeItem={onChangeItem}
                  />
                ) : (
                  <PageLoader />
                )}
              </CardContent>
            </Card>
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
}
